export default "__VITE_ASSET__D2u$HBw2__"